import { render, staticRenderFns } from "./BotaoCancelar.vue?vue&type=template&id=768b9882&scoped=true"
import script from "./BotaoCancelar.vue?vue&type=script&lang=js"
export * from "./BotaoCancelar.vue?vue&type=script&lang=js"
import style0 from "./BotaoCancelar.vue?vue&type=style&index=0&id=768b9882&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b9882",
  null
  
)

export default component.exports